import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { IEntity } from '@proximus/entity-manager';
import { AliasesService } from '../service/aliases.service';
import { DefaultMailboxDomain } from '../config/my-mail.config';
import { Observable } from 'rxjs';
import { debounceTime, every } from 'rxjs/operators';
import { BrandService } from 'src/app/services/brand.service';

@Injectable()
export class CheckAliasValidator {
  constructor(private readonly aliasesService: AliasesService, private readonly brandService: BrandService) {}

  checkAlias(alias: string, domain?: string) {
    const appBrand = this.brandService.getAppBrandValue();
    return (group: UntypedFormGroup): Observable<{ [key: string]: any }> => {
      const aliasValue = group.controls[alias];
      const aliasDomainValue = domain
        ? group.controls[domain].value
        : DefaultMailboxDomain;

      return new Observable((observer: any) => {
        group.valueChanges
          .pipe(
            debounceTime(400),
            every(
              (bool: boolean) =>
                !(aliasValue.value && aliasValue.value.length > 1),
            ),
          )
          .subscribe((bool: boolean) => {
            this.aliasesService
              .checkAlias(`${aliasValue.value}@${aliasDomainValue}`, appBrand)
              .subscribe(
                (checkAlias: IEntity<any>) => {
                  if (checkAlias.value.unique) {
                    observer.next(null);
                  } else {
                    observer.next({ checkAlias: true });
                  }
                },
                (error: any) => {
                  if (error.status === 400) {
                    observer.next({ pattern: true });
                  } else {
                    observer.next({ networkError: true });
                  }
                  observer.complete();
                },
                () => {
                  observer.complete();
                },
              );
          });
      });
    };
  }

  whiteSpaceCheck() {
    return (control: AbstractControl): { [key: string]: any } => {
      const isWhitespace = control.value.indexOf(' ') >= 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }

  atSignCheck() {
    return (control: AbstractControl): { [key: string]: any } => {
      const hasAtSign = control.value.indexOf('@') >= 0;
      return hasAtSign ? { atSign: true } : null;
    };
  }
}
